import { RouteParameters } from "./route-parameters";

const SQUAWKS_ROUTING = {
  CONFIGURE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/squawks/configure`,
  CREATE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/squawks/create`,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/squawks`,
  VIEW: {
    ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/squawks/view`,
    [RouteParameters.SQUAWK_ID]: `/dashboard/:${RouteParameters.AIRPLANE_ID}/maintenance/squawks/view/:${RouteParameters.SQUAWK_ID}`,
  },
} as const;

const SQUAWKS_ROUTES = [
  SQUAWKS_ROUTING.ROOT,
  SQUAWKS_ROUTING.VIEW,
  SQUAWKS_ROUTING.CREATE,
  SQUAWKS_ROUTING.CONFIGURE,
  SQUAWKS_ROUTING.VIEW[RouteParameters.SQUAWK_ID],
] as const;

export { SQUAWKS_ROUTES, SQUAWKS_ROUTING };
